module.exports = __webpack_public_path__ + "media/fonts/FontAwesome-8daab3c4f8252e0c3a3069ac0913b4a4.otf";